import { render, staticRenderFns } from "./OrderStatusesIsVisibleDeliver.vue?vue&type=template&id=fee0790c"
import script from "./OrderStatusesIsVisibleDeliver.vue?vue&type=script&lang=ts"
export * from "./OrderStatusesIsVisibleDeliver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports